import { render, staticRenderFns } from "./ViewNursingCareNotes.vue?vue&type=template&id=f568c8c6&"
import script from "./ViewNursingCareNotes.vue?vue&type=script&lang=js&"
export * from "./ViewNursingCareNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports